
export const productUpdates = [
    {
        title: "Vlad is now Stateful",
        description: "Breaking the stateless barrier: memory, history, and persistent execution.",
        readMore: "vlad.chat"
    },
    {
        title: "Persistent History",
        description: "Your conversations now live forever across all your devices.",
        readMore: "vlad.chat"
    },
    {
        title: "Memory Driven",
        description: "Vlad recalls past context to provide deeper, more relevant assistance.",
        readMore: "vlad.chat"
    },
    {
        title: "Autonomous Agents",
        description: "Delegate tasks that run in the background until they are done.",
        readMore: "vlad.chat"
    },
    {
        title: "Hardened Core",
        description: "A stable, persistent foundation for the future of agentic work.",
        readMore: "vlad.chat"
    }
];
